<template>
  <div class="topbar">
    <div class="top">
      <div :style="style2" class="nav">
        <div class="header">
          <a href="/">
            <div class="logo-box">
              <img class="logo" src="../assets/lj.png" alt="" style="" >
            </div>
          </a>
          <router-link
            :to="{ name: 'homepage', params: {} }"
            class="nav-item"
            @click.native="topChange(1)"
          >首页</router-link
          >
          <router-link
            :to="{ name: 'products', params: {} }"
            class="nav-item"
            @click.native="topChange(2)"
          >产品中心</router-link
          >
          <router-link
            :to="{ name: 'solutions', params: {} }"
            class="nav-item"
            @click.native="topChange(3)"
          >服务中心</router-link
          >
          <router-link
            :to="{ name: 'successCase', params: {} }"
            class="nav-item"
            @click.native="topChange(4)"
          >成功案例</router-link
          >
          <router-link
            :to="{ name: 'aboutUs', params: {} }"
            class="nav-item"
            @click.native="topChange(6)"
          >关于我们</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TopMenu',
  data() {
    return {
      style2: '',
      header: '苏州睿泽信息技术有限公司',
      leader: 'xxxxxxxxxxxxxx',
      status: 0,
      ishome: false,
      info: {},
      isActive: 'home'
    }
  },
  watch: {
    ishome: {
      handler(val, oldvar) {
        if (val === true) {
          this.style2 = 'position:relative'
        } else this.style2 = 'position:absolute'
      },
      immediate: true
    }
  },

  methods: {

    topChange(x) {
      this.status = 1
      switch (x) {
        case 1:
          this.header = '苏州睿泽信息技术有限公司'
          this.leader = 'xxxxxxxxxxxxxx'
          this.isActive = 'home'
          break
        case 2:
          this.header = '产品中心'
          this.leader = '业务、财务一体化高效管理'
          this.isActive = 'product'
          break
        case 3:
          this.header = '服务中心'
          this.leader = '用电管理与计量一站式服务'
          this.isActive = 'solution'
          break
        case 4:
          this.header = '成功案例'
          this.leader = '让空间资产释放价值'
          this.isActive = 'successcase'
          break
        case 5:
          this.header = '关于我们'
          this.leader = '在这里，获得事业的发展和成长'
          this.isActive = 'about'
          break
      }
    }
  }
}
</script>
<style scoped>
.logo {
  width: 110px;
  padding-right: 20px;
  padding-left: 30px;
}
h4 {
  font-weight: bold;
}
.nav {
  width: 100%;
  position: absolute;
  z-index: 2;
  background: #fff;
  box-shadow: 0 0 8px rgb(0 0 0 / 20%);
}

.header {
  display: flex;
  align-content: center;
  align-items: center;
  position: relative;
  /* transform: translateX(-5%); */
  margin: auto;
  white-space: nowrap;
  height: 100px;
}

.nav a {
  padding: 0px 25px 0px 25px;
}
.nav a:hover {
  color: rgba(89, 89, 228, 0.842);
}
.nav-item {
  padding: 0 15px;
}
.topbar {
  margin-top: 0;
  /* height:500px; */
}
.top {
  height: 100px;
}

.top a {
  color: #000;
  font-weight: bold;
  text-decoration: none;
  min-width: 150px;
}

/* .masonry {
    display: flex;
    flex-direction: row;
    text-align: left;
    padding-top: 10px;
} */
.column {
  display: flex;
  flex-direction: column;
  width: calc(100% / 6);
}

.column {
  padding: 20px 20px 100px 20px;
}

.item__content {
  color: black;
  padding: 10px;
}

.item a:hover {
  color: rgb(54, 54, 233);
}

.line {
  color: white;
}

.jumbotron {
  margin: 0;
  z-index: 999;
}
.router-link-exact-active {
  /* text-decoration: underline !important; */
  color: #fa9046 !important;
  font-weight: 800 !important;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/topMenu.vue